import apiClient from "../api";

const authHeaders = () => {
  const token = localStorage.getItem("token");

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getGestockSubscription = async () => {
  try {
    const response = await apiClient.get("gestock/user/subscription", {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const upgradeGestockSubscription = async (planKey, billingCycle) => {
  try {
    const response = await apiClient.patch(
      "gestock/user/subscription",
      { planKey, billingCycle },
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const initializeGestockSubscriptionPayment = async ({
  planKey,
  billingCycle,
  email,
  phone,
  provider,
}) => {
  try {
    const response = await apiClient.post(
      "gestock/user/subscription/initialize-payment",
      { planKey, billingCycle, email, phone, provider },
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
